import { Component, OnInit, Inject, Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Claimant } from '../../models/claimant';
/*import { DatePipe } from '@angular/common';*/


@Component({
  selector: 'app-complete',
  templateUrl: './complete.html',
  styleUrls: ['./complete.css'],
 /* imports: [DatePipe], // Add this using the DatePipe Directive in the template*/
})

  @Injectable({
    providedIn: 'root' // Add this line for LocalStorageService
  })

export class Complete implements OnInit {
  claimant: Claimant = new Claimant();

  constructor(
    private storage: LocalStorageService,
  ) { }

  ngOnInit() {
    const storedClaimant = this.storage.retrieve('claimant');

    if (storedClaimant) {
      this.claimant.claimNumber = storedClaimant.claimNumber;
    }
  }
}

